import { getUserApiKey, isLoggedIn, logoutCallback } from "../app/util/helpers";

export default function setupAxios(axios, store) {
  localStorage.setItem("app_env", `${process.env.REACT_APP_ENV}`);
  axios.interceptors.request.use(
    (config) => {
      const {
        auth: { authToken },
      } = store.getState();

      if (authToken) {
        config.withCredentials = true;
        config.headers.Authorization = getUserApiKey();
        config.headers["Content-Type"] = "application/json";
        config.headers.jwtAuthorization = authToken;
      }

      return config;
    },
    (err) => Promise.reject(err)
  );

  const { dispatch } = store;

  axios.interceptors.response.use(
    function(response) {
      return response;
    },
    function(error) {
      if (
        error &&
        error.response &&
        401 === error.response.status &&
        isLoggedIn()
      ) {
        if(error?.response?.data?.error?.message == 'Invalid token') {
          logoutCallback(true);
        }
      } else {
        return Promise.reject(error);
      }
    }
  );
}
